function get_last_unmatched_status({ status_history, status }) {
  return status_history.filter((e) => e !== status).slice(-1)[0] || "Se"
}

export default function (submission) {
  const last_status = get_last_unmatched_status(submission)
  const status = submission.status

  if (last_status && last_status !== status)
    submission.fullStatus = `${submission.status}-${last_status}`
  else submission.fullStatus = submission.status
  return submission
}
